/* eslint-disable parog-web/no-glint-expect-error-directive */
import { hash } from '@ember/helper';
import { guidFor } from '@ember/object/internals';
import Component from '@glimmer/component';
import type { EmberChangeset } from 'ember-changeset';
import { validatePresence } from 'ember-changeset-validations/validators';
import FormyCheckbox from 'parog-web/components/formy/checkbox';
import FormyDate from 'parog-web/components/formy/date';
import FormyInput from 'parog-web/components/formy/input';
import FormySearch from 'parog-web/components/formy/search';
import FormySelect from 'parog-web/components/formy/select';
import changesetValidatesPresence from 'parog-web/helpers/changeset-validates-presence';
import type FormyComponent from '../formy';

interface Signature {
  Element: HTMLElement;
  Args: {
    formy: FormyComponent;
    key: string;
    label?: string;
  };
  Blocks: {
    default: [{ key; id; Input; Select; Date; Search; Checkbox }];
  };
}

type IErr = EmberChangeset['error'][string];

export default class FormyFieldComponent extends Component<Signature> {
  id = guidFor(this);
  private;

  get error(): IErr['validation'] | undefined {
    const error = this.args.formy.args.changeset.error[this.args.key];

    if (!error) return;

    const errors = error.validation;
    if (!errors) return;

    return errors instanceof Array ? errors[0] : errors;
  }

  get errorId(): string | undefined {
    if (!this.error) return undefined;
    return guidFor(this.error);
  }

  _isPresenceValidation(validation: () => void): boolean {
    return validation.toString() === validatePresence().toString();
  }

  /* prettier-ignore */
  <template>
    <div
      class={{if
        (changesetValidatesPresence @formy.args.changeset @key)
        'required field'
        'field'
      }}
      ...attributes
    >
      {{#if @label}}
        <label for={{this.id}}>{{@label}}</label>
      {{/if}}

      {{yield (hash key=@key id=this.id Input=(component FormyInput parent=this) Select=(component FormySelect parent=this) Date=(component FormyDate parent=this) Search=(component FormySearch parent=this) Checkbox=(component FormyCheckbox parent=this)) }}

      {{#if this.error}}
        <span id={{this.errorId}} class='ui error text'>

          {{! @glint-expect-error }}
          {{this.error}}
        </span>
      {{/if}}
    </div>
  </template>
}
